<template>
    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-title>
                    <v-btn small :to="{name: 'bm',params: { id: id }}" class="mr-4 btn-back">
                        <v-icon>
                            mdi-arrow-left
                        </v-icon>
                        Voltar
                    </v-btn>
                    <v-icon left>mdi-cash-register</v-icon>
                    Saldo do Profissional
                    <v-spacer></v-spacer>
                    <v-chip
                    color="green"
                    outlined
                    class="mr-2"
                    >
                    <v-icon left>mdi-check-circle</v-icon>
                    Liberado
                    {{ bmBalance.balanceReleased | money }}
                    </v-chip>
                    <v-chip
                    color="orange"
                    outlined
                    class="mr-2"
                    >
                    <v-icon left>mdi-clock</v-icon>
                    À Liberar
                    {{ bmBalance.balanceToRelease | money }}
                    </v-chip>
                    <v-chip
                        color="#6D59E8"
                        outlined
                    >
                        <v-icon left small>mdi-currency-usd</v-icon>
                        Caixa
                        {{ bmBalance.moneyBalance | money }}
                    </v-chip>
                    


                    <!--                    <v-switch-->
                    <!--                        v-model="bmCashFlow.active"-->
                    <!--                        :label=" `Exibindo ${bmCashFlow.active? 'Ativos': 'Inativos'}`"-->
                    <!--                        single-line-->
                    <!--                        hide-details-->
                    <!--                        class="mr-3"-->
                    <!--                        style="width: 200px"-->
                    <!--                        @change="buscar()"-->
                    <!--                    ></v-switch>-->

                    <!--                    <v-btn-->
                    <!--                        class="btn-new"-->
                    <!--                        :to="{ name: 'servicesCreate' }"-->
                    <!--                    >-->
                    <!--                        <v-icon left>mdi-plus</v-icon>-->
                    <!--                        Adicionar-->
                    <!--                    </v-btn>-->
                </v-card-title>


                <v-card-text>
                    <v-form ref="formPayment"
                            v-model="formIsValid"
                            v-on:submit.prevent="submitPayment()">
                        <v-row>
                            <v-spacer></v-spacer>
                            <v-col md="4" sm="5" xs="12">
                                <v-select
                                    v-model="bmPay.accountID"
                                    :items="movementAccounts"
                                    item-value="id"
                                    item-text="name"
                                    label="Conta de Movimento"
                                    placeholder="Escolha uma conta de Movimento"
                                    :rules="textRules"
                                    outlined
                                    dense
                                >
                                </v-select>
                            </v-col>
                            <v-col md="2" sm="4" xs="12">
                                <number-input
                                    label="Valor"
                                    v-model="bmPay.value"
                                    placeholder="Informe o Valor "
                                    :options="optionsMoney"
                                    append-icon="mdi-currency-usd"
                                    :rules="Number(bmPay.value) > Number(bmBalance.moneyBalance) ? ['O valor deve ser menor ou igual ao Valor em Caixa.']: textRules"
                                    outlined
                                    dense
                                ></number-input>
                            </v-col>
                            <v-col md="2" sm="3" xs="12">
                                <v-btn outlined :disabled="bmPay.value <= 0 || !bmPay.accountID || Number(bmPay.value) > Number(bmBalance.moneyBalance)" class="btn-lyndus mr-1" type="submit">
                                    <v-icon left>mdi-cash-multiple</v-icon>
                                    Registrar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-alert type="warning" outlined v-show="!bmCashFlow.items"
                >Nenhum Movimento Encontrado
                </v-alert
                >


                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="bmCashFlow.items"
                    :options.sync="options"
                    :server-items-length="bmCashFlow.totalItems"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    item-key="id"
                    class="elevation-1"
                    v-show="bmCashFlow.items"
                    :footer-props="{
                        'items-per-page-options': [10, 25, 50, 75, 100]
                      }"
                >
                    <template v-slot:item.requestDate="{ item }">
                        {{ item.requestDate | formatDate3 }}
                    </template>
                    <template v-slot:item.description="{ item }">
                        <router-link style="text-decoration: none; color: inherit;"
                                     :to="{ name: 'charge', params: { id: item.chargeID } }">{{ item.description }}
                        </router-link>
                    </template>
                    <template v-slot:item.accountMovementName="{ item }">
                        {{ item.accountMovementName }}
                        {{ item.accountReceiptName }}
                    </template>
                    <template v-slot:item.valueReleased="{ item }">
                        {{ item.valueReleased | money }}
                    </template>
                    <template v-slot:item.valueAnticipation="{ item }">
                        {{ item.valueAnticipation | money }}
                    </template>
                    <template v-slot:item.value="{ item }">
                        <b class="green--text" v-if="item.movementType == 'C'">{{ item.value | money }}</b>
                    </template>
                    <template v-slot:item.movementType="{ item }">
                        <b class="red--text" v-if="item.movementType == 'D'">{{ item.value | money }}</b>
                    </template>


                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    class="btn-lyndus"
                                    v-bind="attrs"
                                    v-on="on"
                                    :to="{ name: 'charge', params: { id: item.chargeID } }"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>Visualizar</span>
                        </v-tooltip>
                    </template>
                    <!-- <template v-slot:item.actions="{ item }">
                         <v-tooltip bottom>
                             <template v-slot:activator="{ on, attrs }">
                                 <v-btn
                                     icon
                                     class="btn-lyndus"
                                     v-bind="attrs"
                                     v-on="on"
                                     :to="{ name: 'usersEdit', params: { id: item.id } }"
                                 >
                                     <v-icon>mdi-pencil</v-icon>
                                 </v-btn>
                             </template>
                             <span>Editar</span>
                         </v-tooltip>
                     </template>-->
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>

</template>

<script>
import {mask} from "vue-the-mask";
import {mapGetters} from "vuex";
import store from "@/store";

import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";
import NumberInput from "@/components/NumberInput";

import {
    MOVEMENT_ACCOUNTS_GET
} from "@/store/actions/financial.type";

import {SET_BM_CASH_FLOW_PAGINATION} from "@/store/mutations/bm.type";
import {
    BM_ADD_PAYMENT,
    BM_BALANCE_GET,
    BM_CASH_FLOW_LIST,

} from "@/store/actions/bm.type";


export default {
    name: "bmCashFlow",
    directives: {mask},
    components: {NumberInput},
    props: {
        id: {
            default: 0,
            type: Number,
            required: true,
        },
    },
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        // await store.dispatch(CASH_FLOW_SEARCH);
        // await store.dispatch(BM_CASH_FLOW_LIST)
        await store.dispatch(MOVEMENT_ACCOUNTS_GET);
        return next();
    },
    data: () => ({
        textRules: [
            (v) => !!v || "Este campo é obrigatório",
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        sortBy: 'date',
        sortDesc: true,
        selected: [],
        options: {},
        headers: [
            {text: "Data", align: "left", value: "date"},
            {text: "Descrição", value: "description"},
            {text: "Crédito", value: "value"},
            {text: "Débito", value: "movementType"},

            // {text: "Usuário", value: "username"},
            // {text: "Visualizar", value: "actions", sortable: false}
        ],
        tab: null,
        bankAccountIndex: null,
        localBanks: [],
        search: null,
        balanceRequestValue: 0,
        balanceRequest: {
            value: 0,
            valueReleased: 0,
            valueToReleased: 0,
            valueTotal: 0,
            valueRate: 0,
            bankID: 0
        },

        formIsValid: false,
        optionsMoney: {
            locale: "pt-BR",
            prefix: "R$:",
            length: 9,
            precision: 2
        },
        active: false,
        btnBalanceCheck: true,


        social: {
            socialID: 0,
            url: "",
        },

        balance: {
            socialID: 0,
            url: "",
        },
        subtitle: {
            socialID: 0,
            url: "",
        },

        pixRules: [
            v => !!v && !!this.bankAccount.bank && this.bankAccount.agency && this.bankAccount.account || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],


    }),

    methods: {


        loadExtract() {
            this.buscar()
        },
        async buscar() {
            const {sortBy, sortDesc, itemsPerPage, page} = this.options

            store.commit(SET_BM_CASH_FLOW_PAGINATION, {
                bmID: this.id,
                page: page,
                itemsPerPage: itemsPerPage,
                orderBy: sortBy,
                sortDesc: sortDesc[0]
            })
            await store.dispatch(BM_CASH_FLOW_LIST);
            await store.dispatch(BM_BALANCE_GET, this.id);
        },
        submitPayment() {
            if (this.$refs.formPayment.validate()) {
                this.$store.commit(CHANGE_PROGRESS, true)

                this.$store
                    .dispatch(BM_ADD_PAYMENT, this.id)
                    .then(async () => {

                        this.$store.commit(CHANGE_PROGRESS, false)
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Processado com sucesso";
                        this.$refs.formPayment.resetValidation();

                        this.buscar()

                    })
                    .catch(({response}) => {
                        this.$store.commit(CHANGE_PROGRESS, false)
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao Processar.";
                        // console.log(response.data);
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text = response.data.message;
                        }
                    });
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        },


    },
    watch: {
        search(val) {
            val && val !== this.select && this.querySelections(val)
        },

        options: {
            handler() {
                this.buscar()
            },
            deep: true,
        },
    },
    computed: {
        ...
            mapGetters(["snackbar", "bmCashFlow", "bmCashFlowPagination", "movementAccounts", "bmPay", "bmBalance"]),
    }
    ,
}
;
</script>